import gql from 'graphql-tag';

export default gql`
  mutation signOut($jti: UUID!) {
    signOut(jti: $jti)
  }
`;
